module.exports = __webpack_public_path__ + "img/floor-dianzi.09950b18.png";